import { OnboardingStepCommon, Content, VideoTour } from './OnboardingStepCommon';

const OnboardingStepTwo = ({ videoRef }) => {
  return (
    <OnboardingStepCommon>
      <VideoTour ref={videoRef} name='onboarding-2' />
      <Content>
        <small className='black'>Features you can try on the playground:</small>
        <h3>Autocomplete legal text</h3>
        <p>
          <small>
            Start typing legal language and get inline content predictions. 
            You can also use hot keys to complete sentences or paragraphs
          </small>
        </p>
      </Content>
    </OnboardingStepCommon>
  );
}

export default OnboardingStepTwo;